import { Color } from '@usitsdasdesign/dds-react';
import { getPermsissionToAddFirmInitiative } from 'app/firm-initiatives/page';
import { signOut } from 'next-auth/react';
import { getHelpMenuOptions, getOpportunityMenuOptions, RenderSubMenu } from './HeaderArguments';
import { hideEmpWorkPackagesFeature } from '@/lib/constants';

const getInitials = function (name) {
    const parts = name.split(' ');
    let initials = '';
    for (let i = 0; i < parts.length; i++) {
        if (parts[i].length > 0 && parts[i] !== '') {
            initials += parts[i][0];
        }
    }
    return initials.toUpperCase();
};

const ResourceHeaderArguments = (router, pathname, session, onNotificationClick, setShowDialog, setToastData) => {
    const isActive = (route) => pathname.includes(route) && route !== '/';
    const id = session?.user?.resourceId;
    const isAdminOrRM = ['admin', 'resource_manager', 'guest_rm', 'resource_manager_lead'].some((role) => session?.user?.role?.includes(role));
    const isRecruiterOrHr = ['hrbp', 'recruiter', 'sub_recruiter'].some((role) => session?.user?.role?.includes(role)) && !isAdminOrRM;
    const isPartnerOrManager = ['partner', 'manager'].includes(session?.user?.gradeLevel) && !isAdminOrRM;
    const isResource = session?.user?.gradeLevel === 'resource' && !isPartnerOrManager && !isAdminOrRM;
    const isAuditUser = (session?.user?.function === 'Audit & Assurance' && session?.user?.serviceArea === 'Audit') && session?.user?.grade === 'DM';
    const isTpcrRm = session?.user?.role?.includes('tpcr_rm');
    const isTpcrRmLead = session?.user?.role?.includes('tpcr_rm_lead');
    const isTpcrRmOrRmLead = isTpcrRm || isTpcrRmLead;
    const showTimeSheet = session?.user?.timesheetIndicator === 'YES' && session?.user?.employmentType !== 'TPCR' && !isTpcrRm && !isTpcrRmLead;
    const isStockCountDelegate = session?.isDelegate && session?.delegateType === 'stockCount';
    const isSubCon = session?.user?.employmentType === 'TPCR';
    const isFirmInitiativeDelegate = session?.isDelegate && session?.delegateType === 'firmInitiative';
    const hasAccessToFirmInitiative = getPermsissionToAddFirmInitiative(session?.user) || session?.user?.isSpecificFirmInitiativeOwner;
    const employementType = session?.user?.employmentType;
    const isTpcrResource = employementType === 'TPCR'
    const isshowfaq = session?.user?.employmentType === 'TPCR';


    let menus = [
        {
            title: 'Home',
            isActive: isActive(`/resource-dashboard`),
            onClick: () => router.push('/resource-dashboard')
        },
        {
            title: 'My Profile',
            isActive: isActive(`/my-profile`),
            onClick: () => router.push(`/my-profile`)
        },
        {
            title: 'My Schedules',
            isActive: isActive('my-schedules'),
            onClick: () => router.push('/my-schedules')
        },
        ...(showTimeSheet ? [
            {
                title: 'Timesheet Recommendation',
                isActive: isActive('timesheet'),
                onClick: () => isSubCon ? window.open(process.env.NEXT_PUBLIC_FIELD_GLASS_TIMESHEET_URL, '_blank') : router.push('/timesheet')
            }
        ] : []),
        ...((session?.isDelegate || isTpcrRmOrRmLead || isTpcrResource) ? [] : [{
            title: (
                <RenderSubMenu
                    label='Opportunities'
                    menus={
                        getOpportunityMenuOptions({ isActive, setToastData, type: 'employee', router })
                    }
                />
            ),
            isActive: isActive('job-posting') || isActive('internal-gig-employee') || isActive('firm-initiatives-employee'),
            onClick: () => false
        }]),
        ...((hasAccessToFirmInitiative && isResource) ? [{
            title: 'Firm Initiatives',
            isActive: pathname === '/firm-initiatives-employee' ? false : isActive('firm-initiatives'),
            onClick: () => router.push('/firm-initiatives?employee=true')
        }] : []),
        ...((isResource && isAuditUser) ? [
            {
                title: 'Stock/Cash Count',
                isActive: isActive('stock-count'),
                onClick: () => router.push('/stock-count')
            }
        ] : []),
        ...((isResource && isRecruiterOrHr) ? [
            {
                title: 'Requisitions',
                isActive: isActive('requisition'),
                onClick: () => router.push('/requisitions')
            }
        ] : []),
        ...(!hideEmpWorkPackagesFeature && isResource && !session?.isDelegate && !isTpcrResource ? [
            {
                title: (
                    <RenderSubMenu
                        label='CEC'
                        menus={[
                            {
                                title: 'Work Packages',
                                isActive: isActive('work-packages-employee'),
                                onClick: () => router.push('/work-packages-employee')
                            }
                        ]}
                    />
                ),
                isActive: isActive('work-packages-employee'),
                onClick: () => false
            }
        ] : []),
        // {
        //     title: 'Search Employee',
        //     isActive: isActive('search-employee'),
        //     onClick: () => router.push('/search-employee')
        // },
        {
            title: (
                <RenderSubMenu
                    label='Help'
                    menus={
                        getHelpMenuOptions({ isActive, setToastData, type: 'employee', disableForTpcrRm: !isTpcrRmOrRmLead, isshowfaq })
                    }
                />
            ),
            isActive: false,
            onClick: () => false
        }
    ];
    if (isStockCountDelegate) {
        menus = [{
            title: 'Stock/Cash Count',
            isActive: isActive('stock-count'),
            onClick: () => router.push('/stock-count')
        }]
    }
    if (isFirmInitiativeDelegate) {
        menus = [{
            title: 'Firm initiatives',
            isActive: isActive('firm-initiatives'),
            onClick: () => router.push('/firm-initiatives')
        }]
    }
    return {
        customClass: 'resource-header',
        color: Color.green,
        isInverse: false,
        navigationMenu: menus,
        quickActions: (isStockCountDelegate || isFirmInitiativeDelegate) ? [] : [
            {
                title: 'Notification',
                icon: 'notification__l__stroke',
                isActive: false,
                ariaLabel: 'External Navigation',
                click: onNotificationClick
            }
        ],
        isResponsive: true,
        userProfileData: {
            user: {
                username: session?.user?.name,
                initials: getInitials(session?.user?.name ? session?.user?.name : ''),
                userInfo: session?.user?.designation,
                photoURL: session?.profilePicture
            },
            className: '',
            navigation: [
                ...(!session?.isDelegate ? [{
                    label: 'Delegations',
                    onSelectedItem: () => setShowDialog('Delegates')
                }] : []),
                {
                    isDisabled: false,
                    label: 'Logout',
                    value: 'Logout',
                    onSelectedItem: async () => {
                        await signOut({
                            redirect: true,
                            callbackUrl: process.env.NEXT_PUBLIC_NODE_ENV === 'development'
                                ? '/login' : '/logout'
                        });
                        // removeAuth(null);
                    }
                }
            ]
        },
        responsivePriority: ['logo', 'projectName', 'userProfile', 'links', 'navigation'],
        theme: {},
        customLightLogo: '/images/sPInE-logo.svg',
        customDarkLogo: '/images/sPInE-logo.svg',
        customLogoWidth: '112px',
        customLogoHeight: '36px'
    };
};

export default ResourceHeaderArguments;
